<template>
	<div style="min-width: 600px;">
		<!-- {{date1}} -->
        <div class="row align-items-center">
            <div class="d-flex align-items-center m-1">
                <b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1" today-button close-button locale="zh"></b-form-datepicker>
            </div>
            <!-- 添加板块数量下拉选择框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-select v-model="show_top_n" :options="topNOptions" size="sm"></b-form-select>
            </div>
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_market"
                v-model.number="status_market"
                name="checkbox_market"
                value="1"
                unchecked-value="0"
                size="sm"
                @click="click_show_market"
                >
                行情
                </b-form-checkbox>
            </div>
            <!-- 添加涨停个数复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_count"
                v-model.number="show_count"
                name="checkbox_show_count"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                个数
                </b-form-checkbox>
            </div>
            <!-- 添加时间复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_time"
                v-model.number="show_time"
                name="checkbox_show_time"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                时间
                </b-form-checkbox>
            </div>
            <!-- 添加分数复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_score"
                v-model.number="show_score"
                name="checkbox_show_score"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                分数
                </b-form-checkbox>
            </div>
            <!-- 添加成交额复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_amount"
                v-model.number="show_amount"
                name="checkbox_show_amount"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                成交额
                </b-form-checkbox>
            </div>
            <!-- 添加市值复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_market_value"
                v-model.number="show_market_value"
                name="checkbox_show_market_value"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                市值
                </b-form-checkbox>
            </div>
            
            <!-- 添加封单复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_sealed_order"
                v-model.number="show_sealed_order"
                name="checkbox_show_sealed_order"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                封单
                </b-form-checkbox>
            </div>
            <!-- 添加流通市值复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_circulating_value"
                v-model.number="show_circulating_value"
                name="checkbox_show_circulating_value"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                流通市值
                </b-form-checkbox>
            </div>
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_highlight_multi"
                v-model.number="highlight_multi"
                name="checkbox_highlight_multi"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                标多概念
                </b-form-checkbox>
            </div>
            <!-- 添加分时复选框 -->
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                id="checkbox_show_min_chart"
                v-model.number="show_min_chart"
                name="checkbox_show_min_chart"
                value="1"
                unchecked-value="0"
                size="sm"
                >
                分时
                </b-form-checkbox>
            </div>
            <!-- 添加刷新按钮 -->
            <div class="d-flex align-items-center m-1">
                <b-button size="sm" variant="outline-primary" @click="refresh_page">刷新</b-button>
            </div>
        </div>

		<div class="row">
			<div class="col-1 border alert-primary">梯队/板块</div>
			<div class="col alert-danger border" v-bind:key="plate.index" v-for="plate in plates">
                <div>
                    <span class="badge badge-light" style="cursor:pointer" @click="openPlateModal(plate)">{{plate['name']}} </span>
                    <span class="badge badge-light" v-if="show_count">{{ getPlateNonBrokenStockCount(plate['code']) }}</span>
                </div>
				<div>
					<span class="badge badge-info" v-if="show_score">{{ plate['score'] }}</span>
				</div>
			</div>
		</div>

            <div class="row" v-bind:key="ban" v-for="ban in bans">
			<div v-if="ban==0" class="col-1 border alert-danger">炸 板</div>
			<div v-else class="col-1 border alert-danger">
                {{ban}} 板 
                <span v-if="show_count && ban_info[ban]" class="badge badge-info">{{ban_info[ban].count}}个</span>
                <span v-if="promotion_rates[ban]" class="badge badge-info">{{promotion_rates[ban]}}</span>
            </div>
			
            <div class="col border" style="padding: 0;" v-bind:key="plate['code']" v-for="plate in plates">
				<!-- {{ban}} {{plate['code']}} {{stocks_plate[ban][plate['code']]}} -->
                <div class="stock_item_block" :class="{ 'top-stock-highlight': (highlight_multi===1 && isTopStock(ban, stock['stock_code'])), 'second-stock-highlight': (highlight_multi===1 && isSecondStock(ban, stock['stock_code'])) }" v-bind:key="stock['stock_code']+'_'+plate['code']+'_'+ban+'_'+(stock['up_limit_time']||'')+'_'+idx" v-for="(stock, idx) in stocks_plate[ban][plate['code']]"><!-- {{stock["up_limit_time"]}} {{stock['stock_name']}} {{stock['next_close_pct']}} -->
					<StockMarketItem 
						@show_sidebar="show_sidebar" 
						:is_show_market=status_market 
						:stock_info="stock" 
						:market="stock['market']" 
						:show_time="show_time" 
						:show_amount="show_amount"
						:show_market_value="show_market_value"
						:show_circulating_value="show_circulating_value"
						:show_sealed_order="show_sealed_order"
					></StockMarketItem>
                    <div v-if="show_min_chart===1 && ((Number(ban)>=2) || (show_min_chart_ban1===1 && Number(ban)===1))" class="uplimit-min-chart-placeholder border-bottom" :data-stock-code="stock['stock_code']" style="min-height: 50px;">
                        <StockMiniTrend 
                            v-if="visibleStocks[stock['stock_code']]" 
                            :key="stock['stock_code']+'_'+(status_market===1?'real':date1)+'_'+plate['code']+'_'+ban+'_'+min_chart_refresh_seq"
                            :symbol_code="stock['stock_code']" 
                            :selected_date="status_market===1 ? '' : date1"
                            :refresh_seq="min_chart_refresh_seq"
                            chart_heigh="50px"
                        />
                        <div v-else class="d-flex justify-content-center align-items-center" style="height: 50px; background: var(--bg-muted);">

                            <span class="text-muted small" style="font-size: 10px;">载入中...</span>
                        </div>
                    </div>
				</div>
			</div>
		</div>

		<PlateKlineModal 
			v-if="showPlateModal"
			:visible="showPlateModal" 
			:plateCode="selectedPlateCode" 
			:plateName="selectedPlateName" 
			:selectedDate="date1" 
			@close="closePlateModal"/>
		
        <div class="row align-items-center" style="margin-top:8px;">
            <div class="d-flex align-items-center m-1">
                <b-form-checkbox
                    id="checkbox_show_min_chart_ban1"
                    :key="checkbox_ban1_key"
                    v-model.number="show_min_chart_ban1"
                    name="checkbox_show_min_chart_ban1"
                    value="1"
                    unchecked-value="0"
                    size="sm"
                >首板分时</b-form-checkbox>
            </div>
        </div>
        <b-modal v-model="showLoginPrompt" title="需要登录" hide-footer @hidden="onPromptHidden">
            <div>开启首板分时需要登录账号</div>
            <div class="mt-2">
                <b-button size="sm" variant="primary" @click="goLoginFromPrompt">登录</b-button>
                <b-button size="sm" class="ml-2" variant="secondary" @click="onCancelPrompt">取消</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
	import StockMarketItem from 'components/stock/StockMarketItem.vue'

	import {
		request_zzquant,request_zrx
	} from "network/request.js"

	export default {
		props:{
			// status_market:{type:Number,default:0}	
		},
        components: {
            StockMarketItem,
            PlateKlineModal: ()=>import('components/plate/PlateKlineModal.vue'),
            StockMiniTrend: ()=>import('components/stock/StockMiniTrend.vue')
        },
        mounted() {
			// console.log("mounted");
			// this.update_info();
			// 从localStorage读取状态
			const savedMarketStatus = localStorage.getItem('uplimit_status_market');
			const savedShowCount = localStorage.getItem('uplimit_show_count');
			const savedShowTime = localStorage.getItem('uplimit_show_time');
			const savedShowTopN = localStorage.getItem('uplimit_show_top_n');
			const savedShowScore = localStorage.getItem('uplimit_show_score');
			const savedShowAmount = localStorage.getItem('uplimit_show_amount');
			const savedShowMarketValue = localStorage.getItem('uplimit_show_market_value');
			const savedShowCirculatingValue = localStorage.getItem('uplimit_show_circulating_value');
            const savedShowSealedOrder = localStorage.getItem('uplimit_show_sealed_order');
            const savedHighlightMulti = localStorage.getItem('uplimit_highlight_multi');
            const savedShowMinChart = localStorage.getItem('uplimit_show_min_chart');
            const savedShowMinChartBan1 = localStorage.getItem('uplimit_show_min_chart_ban1');
			
			if (savedMarketStatus !== null) {
				this.status_market = parseInt(savedMarketStatus);
			}
			
			if (savedShowCount !== null) {
				this.show_count = parseInt(savedShowCount);
			}
			
			if (savedShowTime !== null) {
				this.show_time = parseInt(savedShowTime);
			}
			
			if (savedShowTopN !== null) {
				this.show_top_n = parseInt(savedShowTopN);
			}
			
			if (savedShowScore !== null) {
				this.show_score = parseInt(savedShowScore);
			}
			
			if (savedShowAmount !== null) {
				this.show_amount = parseInt(savedShowAmount);
			}
			
			if (savedShowMarketValue !== null) {
				this.show_market_value = parseInt(savedShowMarketValue);
			}
			
			if (savedShowCirculatingValue !== null) {
				this.show_circulating_value = parseInt(savedShowCirculatingValue);
			}
			
            if (savedShowSealedOrder !== null) {
                this.show_sealed_order = parseInt(savedShowSealedOrder);
            }
            if (savedHighlightMulti !== null) {
                this.highlight_multi = parseInt(savedHighlightMulti);
            }
            if (savedShowMinChart !== null) {
                this.show_min_chart = parseInt(savedShowMinChart);
            }
            if (savedShowMinChartBan1 !== null) {
                this.show_min_chart_ban1 = parseInt(savedShowMinChartBan1);
            }
			
			// 获取交易日期
			request_zrx({url:'/open/tradedays'}).then(
				res => {
					let days = res['data']['data']
					this.all_trading_days = days;
					this.date1 = days[days.length-1];
					// 加载数据
					this.update_info(this.date1);
				}
			);
            if(this.show_min_chart) {
                this.$nextTick(this.initObserver)
            }
		},
        beforeDestroy(){ 
            if(this.observer){ this.observer.disconnect() }
        },
        watch:{
			// status_market:this.update_info
			status_market(newVal) {
				localStorage.setItem('uplimit_status_market', newVal);
				this.update_info(this.date1);
			},
			show_count(newVal) {
				localStorage.setItem('uplimit_show_count', newVal);
			},
			show_time(newVal) {
				localStorage.setItem('uplimit_show_time', newVal);
			},
			show_top_n(newVal) {
				localStorage.setItem('uplimit_show_top_n', newVal);
				// 当改变板块数量时，重新加载数据
				this.update_info(this.date1);
			},
			show_score(newVal) {
				localStorage.setItem('uplimit_show_score', newVal);
			},
			show_amount(newVal) {
				localStorage.setItem('uplimit_show_amount', newVal);
			},
			show_market_value(newVal) {
				localStorage.setItem('uplimit_show_market_value', newVal);
			},
			show_circulating_value(newVal) {
				localStorage.setItem('uplimit_show_circulating_value', newVal);
			},
            show_sealed_order(newVal) {
                localStorage.setItem('uplimit_show_sealed_order', newVal);
            },
            highlight_multi(newVal) {
                localStorage.setItem('uplimit_highlight_multi', newVal);
            },
            show_min_chart(newVal) {
                localStorage.setItem('uplimit_show_min_chart', newVal);
                if(newVal) {
                    this.$nextTick(this.initObserver)
                } else {
                    if(this.observer) {
                        this.observer.disconnect()
                        this.observer = null
                    }
                    this.visibleStocks = {}
                }
            },
            show_min_chart_ban1(newVal) {
                localStorage.setItem('uplimit_show_min_chart_ban1', newVal);
                if(newVal && this.show_min_chart) {
                    this.$nextTick(this.observeStockRows)
                }
                if (parseInt(newVal) === 1) {
                    let token = ''
                    try { token = localStorage.getItem('token') || '' } catch(e) { token = '' }
                    if (!token) {
                        this.show_min_chart_ban1 = 0
                        localStorage.setItem('uplimit_show_min_chart_ban1', 0)
                        this.loginRedirect = (this.$route && this.$route.fullPath) || (window.location && window.location.pathname) || '/'
                        this.$nextTick(() => { this.showLoginPrompt = true })
                        this.checkbox_ban1_key++
                    }
                }
            }
        },
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
            return {
                status_market: 0,
                show_count: 1, // 修改为默认显示涨停个数
                show_time: 1, // 默认显示时间
                show_score: 0, // 默认不显示分数
                show_amount: 0, // 默认不显示成交额
                show_market_value: 0, // 默认不显示市值
                show_circulating_value: 0, // 默认不显示流通市值
                show_sealed_order: 0, // 默认不显示封单
                highlight_multi: 0,
                show_min_chart: 0,
                show_min_chart_ban1: 0,
                checkbox_ban1_key: 0,
                showLoginPrompt: false,
                loginRedirect: '',
                show_top_n: 12, // 默认显示12个板块
                topNOptions: [
                    { value: 5, text: '显示板块: 5个' },
                    { value: 8, text: '显示板块: 8个' },
                    { value: 10, text: '显示板块: 10个' },
					{ value: 12, text: '显示板块: 12个' },
					{ value: 15, text: '显示板块: 15个' },
					{ value: 20, text: '显示板块: 20个' }
				],
				min_chart_refresh_seq: 0,
				date1: today,
				bans: [5, 4, 3, "炸"],
				ban_info: {},
				plates: [{
					"name": "loading...",
					"code": "8001",
					"score":0,
				}, 
				// {
				// 	"name": "loading...",
				// 	"code": "8003",
				// 	"score":0,
				// }, {
				// 	"name": "loading...",
				// 	"code": "8003",
				// 	"score":0,
				// }
			],
				stocks_plate: {
					"5": {
						"8001": [{
							"stock_name": "loading...",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
					},
					"4": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
					"3": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
					"炸": {
						"8001": [{
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}, {
							"stock_name": "loading",
							"up_limit_time":"09:00",
							"market":{"px_change_rate":0},
						}],
						"8002": [],
						"8003": [],
					},
				},
                topStocksByBan: {},
                showPlateModal:false,
                selectedPlateCode:'',
                selectedPlateName:'',
                all_trading_days: [],
                promotion_rates: {},
                visibleStocks: {},
                observer: null,
            };
        },

		methods: {
            initObserver() {
				if (this.observer) {
					this.observer.disconnect();
				}
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							const stockCode = entry.target.dataset.stockCode;
							if (stockCode && !this.visibleStocks[stockCode]) {
								this.$set(this.visibleStocks, stockCode, true);
								this.observer.unobserve(entry.target);
							}
						}
					});
				}, {
					rootMargin: '100px'
				});
				this.observeStockRows();
			},
			observeStockRows() {
				if (!this.observer) return;
				const elements = this.$el.querySelectorAll('.uplimit-min-chart-placeholder');
				elements.forEach(el => {
					if (!this.visibleStocks[el.dataset.stockCode]) {
						this.observer.observe(el);
					}
				});
			},
			refresh_page() {
				this.update_info(this.date1);
				this.min_chart_refresh_seq++;
			},
			checkIsPreviousTradingDay(dateStr) {
				if (!this.all_trading_days || this.all_trading_days.length === 0) return false;
				
				const now = new Date();
				// Format today as YYYY-MM-DD
				const year = now.getFullYear();
				const month = (now.getMonth() + 1).toString().padStart(2, '0');
				const day = now.getDate().toString().padStart(2, '0');
				const today = `${year}-${month}-${day}`;
				
				// Find the latest trading day strictly before today
				let prevDay = null;
				for (let i = this.all_trading_days.length - 1; i >= 0; i--) {
					const d = this.all_trading_days[i];
					if (d < today) {
						prevDay = d;
						break;
					}
				}
				
				return dateStr === prevDay;
			},
			isLimitUp(stock) {
				if (!stock || !stock.market) return false;
				const rate = stock.market.px_change_rate;
				const code = String(stock.stock_code || '');
				const name = String(stock.stock_name || '');
				
				if (rate === undefined || rate === null) return false;
				
				// Simple thresholds for Limit Up
				// ChiNext (30) and STAR (68) -> 20%
				if (code.startsWith('30') || code.startsWith('68')) {
					return rate >= 19.5;
				} 
				// BSE (8) -> 30%
				else if (code.startsWith('8')) {
					return rate >= 29.5;
				} 
				// ST stocks -> 5%
				else if (name.includes('ST')) {
					return rate >= 4.5;
				} 
				// Main board -> 10%
				else {
					return rate >= 9.5;
				}
			},
			calculatePromotionRates() {
				this.promotion_rates = {};
				
				// Condition 1: Must be previous trading day
				if (!this.checkIsPreviousTradingDay(this.date1)) {
					return;
				}
				
				// Condition 2: Market switch must be on
				if (this.status_market !== 1) {
					return;
				}
				
				for (const ban in this.stocks_plate) {
					// Skip if ban is 0 (Broken) or non-numeric key (though bans array usually has integers and "炸")
					// User said "In the echelon", usually implies the numbered echelons. 
					// But let's calculate for all numeric bans > 0.
					if (ban == 0 || ban === '炸') continue;
					
					const distinctStocks = new Set();
					let limitUpCount = 0;
					
					// Iterate through all plates in this ban
					for (const plateCode in this.stocks_plate[ban]) {
						const stocks = this.stocks_plate[ban][plateCode];
						if (stocks && stocks.length) {
							stocks.forEach(stock => {
								// Use stock_code for deduplication
								if (!distinctStocks.has(stock.stock_code)) {
									distinctStocks.add(stock.stock_code);
									if (this.isLimitUp(stock)) {
										limitUpCount++;
									}
								}
							});
						}
					}
					
					const total = distinctStocks.size;
					if (total > 0) {
						// Format percentage
						const rate = Math.round((limitUpCount / total) * 100) + '%';
						this.$set(this.promotion_rates, ban, rate);
					}
				}
			},
			show_sidebar(stock_info){
				if (!stock_info['date1']) {
					stock_info['date1'] = this.date1;
				}
				this.$emit('show_sidebar',stock_info)
			},
            click_show_market(){
                console.log("click");
                this.update_info(this.date1);
            },
            goLoginFromPrompt(){
                const redirect = this.loginRedirect || (this.$route && this.$route.fullPath) || '/'
                if (this.$router && this.$router.push) {
                    this.$router.push({ path: '/login', query: { redirect } })
                } else {
                    try { window.location.href = '/login?redirect=' + encodeURIComponent(redirect) } catch(e) { /* ignore */ }
                }
                this.showLoginPrompt = false
            },
            onDatePicked(ctx) {
                // console.log(ctx.selectedYMD);
                this.date1 = ctx.selectedYMD;
                // console.log(this.date1);
                this.update_info(this.date1);
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			real_time_info_stock(real_time_stocks,stock) {
				
				if(!real_time_stocks) return false;
				
				var fields = real_time_stocks['fields']
				var values = real_time_stocks['values']
				
				var idx = fields.indexOf(stock)
				// console.log(fields,values,stock,idx);
				if(idx > -1){
					return values[idx]
				}
				return false
			},
			getPlateNonBrokenStockCount(plateCode) {
				let count = 0;
				for (let ban in this.stocks_plate) {
				if (ban != 0 && this.stocks_plate[ban][plateCode]) {
					count += this.stocks_plate[ban][plateCode].length;
				}
				}
				return count;
			},
			update_table_info(res,res2){
				// console.log(res2);
				let data = res['data']['data'];
				let plates = data['plate'];
				let plate_stocks = data['plate_stocks']
				let ban_info = data['ban_info'] || {}; // 获取ban_info数据
				this.ban_info = ban_info;
				// 更新板块显示
				let plate_arr = [];
                plates.forEach((item) => {
                    plate_arr.push({
                        "name": item[0],
                        "code": item[1],
                        "score": item[2]
                    })
                });
				// // 添加其他版块
				// plate_arr.push({
				// 	"name": '其他',
				// 	"code": '000000',
				// 	"score": 0
				// })
				this.plates = plate_arr;
				
				// 更新最高板数梯队
				let ban_arr = [];
				for (let i = data.max_count; i > -1; i--) {
					ban_arr.push(i);
				}
				// ban_arr.push(0)
				this.bans = ban_arr;
				
				// 更新板块下的股票列表
				let stocks_plate_dict = {};
				
				for (let idx in ban_arr) { //从高到低的板数梯队
					let ban = ban_arr[idx]
					stocks_plate_dict[ban] = {}
					plates.forEach((item) => {
						let plate_code = item[1]
						stocks_plate_dict[ban][plate_code] = [] //某板块下的数据
						let stocks_on_plate = plate_stocks[plate_code] //股票列表
						stocks_on_plate.forEach((item2) => {
							if (item2['up_limit_keep_times'] == ban) {
								if(this.status_market==1 && res2){
									let market = this.real_time_info_stock(res2['data']['data'],item2['stock_code']);
									// console.log(market);
									item2['market']  = market;
								}else{
									item2['market']  = {"px_change_rate":0,"open_px_rate":0}
								}
								stocks_plate_dict[ban][plate_code].push(item2)
								// console.log(ban,plate_code,stocks_plate_dict[ban][plate_code]);
							}
						})
						// 按照时间正序排序
						stocks_plate_dict[ban][plate_code].sort((a, b) => {
							const t1 = a.up_limit_time || '';
							const t2 = b.up_limit_time || '';
							return t1.localeCompare(t2);
						});
					});
				}
				this.stocks_plate = stocks_plate_dict;
                if(this.show_min_chart) {
                    this.$nextTick(this.observeStockRows);
                }
				this.computeTopStocksByBan();
				this.calculatePromotionRates();
			},
			computeTopStocksByBan(){
				const result = {};
				for(const ban in this.stocks_plate){
					if(String(ban)==='0'){ result[ban] = { tops1:{}, tops2:{}, max1:0, max2:0, counts:{} }; continue; }
					const counts = {};
					for(const plateCode in this.stocks_plate[ban]){
						const list = this.stocks_plate[ban][plateCode] || [];
						for(const it of list){
							const code = String(it['stock_code']||'');
							if(!code) continue;
							counts[code] = (counts[code]||0)+1;
						}
					}
					const vals = Object.values(counts).filter(v=>v>0).sort((a,b)=>b-a);
					const max1 = vals.length>0 ? vals[0] : 0;
					const max2 = vals.length>1 ? vals[1] : 0; // 次高可以等于最高频次
					const tops1 = {};
					const tops2 = {};
					if(max1>=3){ for(const c in counts){ if(counts[c]===max1) tops1[c]=true; } }
					if(max2>=3){ for(const c in counts){ if(counts[c]===max2) tops2[c]=true; } }
					result[ban] = { tops1, tops2, max1, max2, counts };
				}
				this.topStocksByBan = result;
			},
			isTopStock(ban, code){
				if(Number(ban)===0) return false;
				const info = this.topStocksByBan && this.topStocksByBan[ban];
				if(!info || !info.tops1) return false;
				const k = String(code||'');
				const cnt = (info.counts && info.counts[k]) || 0;
				if(cnt<3) return false;
				return !!info.tops1[k];
			},
			isSecondStock(ban, code){
				if(Number(ban)===0) return false;
				const info = this.topStocksByBan && this.topStocksByBan[ban];
				if(!info || !info.tops2) return false;
				const k = String(code||'');
				const cnt = (info.counts && info.counts[k]) || 0;
				if(cnt<3) return false;
				return !!info.tops2[k];
			},
            update_info(date1) {
				// console.log(self.date1);
                request_zzquant({
                    url: 'v3/open/review/uplimit/hot?date1=' + date1 + '&limit=' + this.show_top_n,
                }).then(res => {
					if(this.status_market==1){
						let data = res['data']['data'];
						if(data['stocks'] && data['stocks'].length > 0) {
							request_zzquant({
								url: '/open/market/real?symbols='+data['stocks']
							}).then(res2 => {
								this.update_table_info(res,res2);
							})
						} else {
							this.update_table_info(res);
						}
					}else{
						this.update_table_info(res)
					}
                })
            }
            ,openPlateModal(plate){
                this.selectedPlateCode = String(plate && plate.code || '')
                this.selectedPlateName = String(plate && plate.name || '')
                if(!this.selectedPlateCode){ return }
                this.showPlateModal = true
            }
            ,closePlateModal(){ this.showPlateModal=false }
            ,onCancelPrompt(){
                this.showLoginPrompt = false
                this.show_min_chart_ban1 = 0
                try { localStorage.setItem('uplimit_show_min_chart_ban1', 0) } catch(e) { /* ignore */ }
                this.checkbox_ban1_key++
            }
            ,onPromptHidden(){
                this.show_min_chart_ban1 = 0
                try { localStorage.setItem('uplimit_show_min_chart_ban1', 0) } catch(e) { /* ignore */ }
                this.checkbox_ban1_key++
            }
        },

	}
</script>

<style>
.stock_item_block{
	font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
	font-size: 14px;
	line-height: 1.42857143;
	color: var(--text-main);
	background-color: var(--bg-card);
	margin-left: 0px;
}

/* 添加badge样式 */
.badge {
  margin-left: 5px;
  font-size: 12px;
  background-color: var(--bg-card);
  color: #dc3545;
  border: 1px solid #dc3545;
}
.second-stock-highlight{ background-color: rgba(0, 123, 255, 0.1); border:1px solid rgba(0, 123, 255, 0.3); }
.top-stock-highlight{ background-color: rgba(255, 193, 7, 0.1); border:1px solid rgba(255, 193, 7, 0.3); }

body.theme-dark .second-stock-highlight { background-color: rgba(0, 123, 255, 0.2); }
body.theme-dark .top-stock-highlight { background-color: rgba(255, 193, 7, 0.2); }

</style>
